






import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import BookingRoleWorkerShiftStatus from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus';


@Component({
  name: 'BookingRoleWorkerShiftStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: BookingRoleWorkerShiftStatus;
	bookingRoleWorkerShiftStatus = BookingRoleWorkerShiftStatus;

	get color() {
		let color = "green";
		switch (this.status) {
			case BookingRoleWorkerShiftStatus.Shortlisted:
				color = "light grey"
				break;
			case BookingRoleWorkerShiftStatus.Offered:
				color = "yellow"
				break;
			case BookingRoleWorkerShiftStatus.DeclinedOffer:
			case BookingRoleWorkerShiftStatus.DeclinedBooking:
				color = "pink"
				break;
			case BookingRoleWorkerShiftStatus.Applied:
				color = "orange"
				break;
			case BookingRoleWorkerShiftStatus.Rejected:
				color = "red"
				break;
			case BookingRoleWorkerShiftStatus.Cancelled:
				color = "dark red"
				break;
			case BookingRoleWorkerShiftStatus.Reserve:
				color = "light blue"
				break;
			case BookingRoleWorkerShiftStatus.BookedUnconfirmed:
			case BookingRoleWorkerShiftStatus.BookedConfirmed:
				color = "green"	
				break;	
			default:
				color = "white"
				break;
		}
		return color;
	}
	
	get textColor() {
		let color = "black";
		switch (this.status) {
			case BookingRoleWorkerShiftStatus.Offered:
			case BookingRoleWorkerShiftStatus.Applied:
			case BookingRoleWorkerShiftStatus.BookedUnconfirmed:
				color = "black"
				break;
			case BookingRoleWorkerShiftStatus.Retracted:
			case BookingRoleWorkerShiftStatus.DeclinedOffer:
			case BookingRoleWorkerShiftStatus.DeclinedBooking:
			case BookingRoleWorkerShiftStatus.Shortlisted:
			case BookingRoleWorkerShiftStatus.Rejected:
			case BookingRoleWorkerShiftStatus.Cancelled:
			case BookingRoleWorkerShiftStatus.BookedConfirmed:
				color = "white"
				break;
			default:
				color = "black"
				break;
		}
		return color;
	}

	get outlined() {
		if (this.status == BookingRoleWorkerShiftStatus.BookedUnconfirmed){
			return true;
		} 
		return false;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case BookingRoleWorkerShiftStatus.Shortlisted:
				text = "SHORTLISTED";
				break;
			case BookingRoleWorkerShiftStatus.Offered:
				text = "OFFERED";
				break;
			case BookingRoleWorkerShiftStatus.Retracted:
				text =  "RETRACTED"
				break;
			case BookingRoleWorkerShiftStatus.DeclinedOffer:
				text =  "DECLINED OFFER"
				break;
			case BookingRoleWorkerShiftStatus.Applied:
				text =  "APPLIED"
				break;
			case BookingRoleWorkerShiftStatus.Rejected:
				text =  "REJECTED"
				break;
			case BookingRoleWorkerShiftStatus.BookedUnconfirmed:
				text = "BOOKED UNCONFIRMED"
				break;	
			case BookingRoleWorkerShiftStatus.DeclinedBooking:
				text =  "DECLINED BOOKING"
				break;
			case BookingRoleWorkerShiftStatus.BookedConfirmed:
				text = "BOOKED CONFIRMED"
				break;
			case BookingRoleWorkerShiftStatus.Cancelled:
				text =  "CANCELLED"
				break;	
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}	
}
